<div class="control">
    <div class="select">
        <select (change)="adjustUseFilter($event)" [value]="Enabled">
            <option value="true" style="color:gray">In Use</option>
            <option value="false" style="color:gray">Not In Use</option>
            <option value="" style="color:gray">All</option>
        </select>
    </div>
</div>
